import {requirePermission} from '@/modules/auth/permissions'
import {ProtocolForm} from '@/modules/protocols/components/protocol-form/protocol-form'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const EditProtocolPageSchema = z.object({
  protocolId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/protocols/new')({
  beforeLoad: requirePermission('protocols.manage'),
  component: NewProtocolContainer,
  validateSearch: EditProtocolPageSchema,
})

function NewProtocolContainer() {
  const {t} = useTranslate('common')

  const {protocolId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={protocolId ? t('edit_protocol_title') : t('new_protocol_title')}
        description={t('new_protocol_description')}
      />

      <ProtocolForm protocolId={protocolId} />
    </NewResourceFormContainer>
  )
}
